import React, { FC } from 'react';
import { Box, Grid } from '@material-ui/core';
import { GetCustomizeCar_customizeCar_additionalGovernmentTaxes } from '../../../../../../../graphql/queries/__generated__/GetCustomizeCar';
import SummaryLabelTitle from '../../../summaryLabel/SummaryLabelTitle';
import PriceValue from '../priceValue/PriceValue';
import summaryLabelStyles from '../../../summaryLabel/SummaryLabelStyles';
import { PriceDisplayType } from '../../../../../../../../../../common/enum/PriceDisplayType';
import clsx from 'clsx';

export interface IAdditionalTaxesProps {
  loading?: boolean;
  additionalGovernmentTaxes: GetCustomizeCar_customizeCar_additionalGovernmentTaxes[];
}

const AdditionalTaxes: FC<IAdditionalTaxesProps> = ({ loading, additionalGovernmentTaxes }) => {
  const styles = summaryLabelStyles();

  return (
    <>
      {additionalGovernmentTaxes.map(tax => {
        return (
          <Grid
            key={tax.name.split(' ').join('')}
            container={true}
            justifyContent={'space-between'}
            spacing={3}
            className={styles.lineContainer}
          >
            <SummaryLabelTitle
              label={
                <Box
                  data-test="customise:summary:additional_government_taxes"
                  component="span"
                  className={clsx(styles.label, styles.payableLabel)}
                >
                  {tax.name}
                </Box>
              }
              boldLabel={true}
              colSm={8}
              colXs={6}
            />
            <PriceValue
              loading={loading}
              price={tax.money.amount}
              priceType={PriceDisplayType.PRIMARY}
              currency={tax.money.currency}
              boldPrice={true}
              testId={'additional_government_taxes'}
            />
          </Grid>
        );
      })}
    </>
  );
};

export default AdditionalTaxes;
